import { useEffect, useState } from 'react';

// WebSocket URL of the crowd room (see worker/). Unset = always play solo.
const CROWD_URL = process.env.REACT_APP_CROWD_URL;
const PING_MS = 30000;
const MAX_RETRY_MS = 60000;

// Live number of players online (including you), or null when not connected.
// Reconnects with backoff, so a server hiccup just means solo for a while.
export default function useCrowd() {
    const [players, setPlayers] = useState(null);

    useEffect(() => {
        if (!CROWD_URL || typeof WebSocket === 'undefined') return;
        let socket;
        let retries = 0;
        let retryTimer;
        let pingTimer;
        let stopped = false;

        const connect = () => {
            socket = new WebSocket(CROWD_URL);
            socket.onopen = () => {
                retries = 0;
                pingTimer = setInterval(() => {
                    if (socket.readyState === WebSocket.OPEN) socket.send('ping');
                }, PING_MS);
            };
            socket.onmessage = (event) => {
                if (event.data === 'pong') return;
                try {
                    const message = JSON.parse(event.data);
                    if (message.type === 'crowd' && Number.isFinite(message.players)) setPlayers(message.players);
                } catch {
                    // Ignore anything we don't understand.
                }
            };
            socket.onclose = () => {
                clearInterval(pingTimer);
                setPlayers(null);
                if (stopped) return;
                retryTimer = setTimeout(connect, Math.min(MAX_RETRY_MS, 1000 * 2 ** retries));
                retries += 1;
            };
        };

        connect();
        return () => {
            stopped = true;
            clearTimeout(retryTimer);
            clearInterval(pingTimer);
            if (socket) socket.close();
        };
    }, []);

    return players;
}
